import SessionManagerRecord, { SessionManagerRecordSource } from '../lib/SessionManagerRecord.js';
import ContactType from './ContactType.js';
/**
 * @property {number} id
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} fullName
 * @property {boolean} isSuperuser
 * @property {?string} emailAddress
 * @property {?string} authorizationToken
 */
class ApplicationUser extends SessionManagerRecord {
    get fullName() {
        return `${this.firstName} ${this.lastName}`.trim();
    }
    get emailAddress() {
        const email = (this.communications || []).find(communication => communication.contactType === ContactType.EMAIL);
        return email ? email.contactValue.toLowerCase() : null;
    }
    get authorizationToken() {
        const token = (this.authTokens || [])[0];
        return token ? token.key : null;
    }
    /**
     * @param tokens
     */
    setToken(token) {
        this.authTokens = [token];
    }
}
ApplicationUser.$AR = {
    url: '',
    SourceClass: SessionManagerRecordSource,
};
export default ApplicationUser;
